module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scroller",
    staticStyle: {
      "overflow-y": "auto",
      "scroll-behavior": "smooth"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5359c51a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ScrollDownDiv.vue
// module id = 2550
// module chunks = 1